import * as React from "react";
import { cn } from "@shortsworks/ui/lib/utils";

const MainDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm text-muted-foreground", className)}
    {...props}
  />
));
MainDescription.displayName = "MainDescription";

export { MainDescription };
